<template>
  <b-modal
    v-model="show"
    centered
    size="md"
    :no-close-on-backdrop="submitting"
    :no-close-on-esc="submitting"
    @hidden="onHidden"
  >
    <template #modal-title>
      <h3 class="font-weight-bold">Approve this file?</h3>
    </template>

    <p class="mb-3">This will mark the file as approved by your company.</p>

    <b-form-group
      label="Comment"
      label-for="approve-comment"
      label-class="font-weight-bold"
    >
      <template #label>
        Comment <span class="text-secondary small">(optional)</span>
      </template>
      <b-form-textarea
        id="approve-comment"
        v-model="reason"
        rows="4"
        max-rows="8"
        placeholder="Add an optional note for this approval"
        :state="reasonState"
        :disabled="submitting"
        aria-describedby="approve-comment-feedback"
      />
      <b-form-invalid-feedback id="approve-comment-feedback">
        {{ errorMessage }}
      </b-form-invalid-feedback>
    </b-form-group>

    <template #modal-footer>
      <div class="d-flex justify-content-end" style="gap: 12px">
        <b-button
          variant="secondary"
          :disabled="submitting"
          @click="closeDialog"
        >
          Cancel
        </b-button>
        <b-button variant="success" :disabled="submitting" @click="onConfirm">
          <b-spinner v-if="submitting" small label="Submitting" />
          <span v-else
            >Approve<span class="d-none d-sm-inline"> file</span></span
          >
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'ApproveFileModal',

  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    fileName: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      reason: '',
      submitting: false,
      errorMessage: '',
    }
  },

  computed: {
    show: {
      get() {
        return this.showModal
      },
      set() {
        this.closeDialog()
      },
    },
    trimmedReason() {
      return (this.reason || '').trim()
    },
    reasonState() {
      if (this.errorMessage) return false
      return null
    },
  },

  watch: {
    showModal(val) {
      if (val) {
        this.reason = ''
        this.errorMessage = ''
        this.submitting = false
      }
    },
  },

  methods: {
    closeDialog() {
      if (this.submitting) return
      this.$emit('close')
    },

    onHidden() {
      this.reason = ''
      this.errorMessage = ''
      this.submitting = false
    },

    onConfirm() {
      if (this.submitting) return
      this.submitting = true
      this.errorMessage = ''
      this.$emit('confirm', {
        reason: this.trimmedReason,
        done: (err) => {
          this.submitting = false
          if (err) {
            const payload = err && err.response && err.response.data
            if (err && err.response && err.response.status === 422) {
              this.errorMessage =
                (payload && (payload.message || payload.error)) ||
                'Please check the comment and try again.'
              return
            }
            this.errorMessage =
              (payload && payload.message) ||
              (err && err.message) ||
              'Could not approve file.'
            return
          }
          this.$emit('close')
        },
      })
    },
  },
}
</script>
